<div [formGroup]="form">
    <mat-form-field *ngIf="vehicleTypeList?.length" appearance="fill" class="w-full">
        <mat-label>Tipo de Vehículo</mat-label>
        <mat-select formControlName="vehicleTypeId" placeholder="Seleccione un Tipo de Vehículo" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(vehicleTypeList, form.get('vehicleTypeId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option *ngFor="let vehicleType of vehicleTypeList" [value]="vehicleType._id">
                {{ vehicleType.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="vehicle" appearance="fill" class="w-full">
        <mat-label>Vehiculos</mat-label>
        <mat-select formControlName="vehicleId" placeholder="Seleccione un vehiculo" multiple
        (selectionChange)="getVehicles(searchVehicles || '', $event.value)">

            <mat-select-trigger>
                {{ getDisplayValueForMongoId(vechicleList, form.get('vehicleId')?.value, 'name') }}
            </mat-select-trigger>

            <!-- Campo de búsqueda -->
            <mat-option>
                <ngx-mat-select-search
                    [formControl]="form.get('searchVehicles')"
                    placeholderLabel="Buscar vehículos..."
                    noEntriesFoundLabel="No se encontraron resultados">
                </ngx-mat-select-search>
            </mat-option>

            <!-- Opciones -->
            <mat-option *ngFor="let vehicle of filteredvechicleList" [value]="vehicle._id">
                <div class="text-sm uppercase leading-tight">
                    <div>
                        <b class="f-9" *ngIf="getCode(vehicle) as code">{{ code }}</b>
                    </div>
                    {{ vehicle.name }}
                </div>
            </mat-option>
        </mat-select>
    </mat-form-field>

</div>